import { combineReducers } from "redux";

import authReducer from "./authReducer";
import usersReducer from "./usersReducer";
import usersPublicReducer from "./usersPublicReducer";

import quiz1Reducer from "./quiz1Reducer";
import quiz2Reducer from "./quiz2Reducer";
import quiz3Reducer from "./quiz3Reducer";
import quiz4Reducer from "./quiz4Reducer";
import quiz4OnGoingReducer from "./quiz4OnGoingReducer";
import sessionReducer from "./sessionReducer";
import classCodesReducer from "./classCodesReducer";
import locationReducer from "./locationReducer";
import earlyVotingReducer from "./earlyVotingReducer";
import finalVotingReducer from "./finalVotingReducer";
import awardsReducer from "./awardsReducer";
import feedbackReducer from "./feedbackReducer";

export default combineReducers({
  auth: authReducer,
  users: usersReducer,
  usersPublic: usersPublicReducer,
  quiz1: quiz1Reducer,
  quiz2: quiz2Reducer,
  quiz3: quiz3Reducer,
  quiz4: quiz4Reducer,
  quiz4OnGoing: quiz4OnGoingReducer,
  session: sessionReducer,
  classCodes: classCodesReducer,
  location: locationReducer,
  earlyVoting: earlyVotingReducer,
  finalVoting: finalVotingReducer,
  awards: awardsReducer,
  feedback: feedbackReducer
});
